import { render, staticRenderFns } from "./controlFiles-add-or-update.vue?vue&type=template&id=8b3962f0&scoped=true"
import script from "./controlFiles-add-or-update.vue?vue&type=script&lang=js"
export * from "./controlFiles-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./controlFiles-add-or-update.vue?vue&type=style&index=0&id=8b3962f0&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3962f0",
  null
  
)

export default component.exports